/** Parse #RRGGBB or #RGB to normalized RGB. */
export function parseHexColor(hex: string, fallback = { r: 1, g: 1, b: 1 }): { r: number; g: number; b: number } {
  const h = (hex || '').trim().replace('#', '');
  if (h.length === 3) {
    const r = parseInt(h[0] + h[0], 16) / 255;
    const g = parseInt(h[1] + h[1], 16) / 255;
    const b = parseInt(h[2] + h[2], 16) / 255;
    return { r, g, b };
  }
  if (h.length >= 6) {
    const r = parseInt(h.slice(0, 2), 16) / 255;
    const g = parseInt(h.slice(2, 4), 16) / 255;
    const b = parseInt(h.slice(4, 6), 16) / 255;
    return { r, g, b };
  }
  return fallback;
}

export function colorFromParams(
  params: Record<string, number>,
  prefix = 'color',
  fallback = { r: 1, g: 0.82, b: 0.48 },
): { r: number; g: number; b: number } {
  if (params[`${prefix}R`] != null) {
    return {
      r: params[`${prefix}R`],
      g: params[`${prefix}G`] ?? fallback.g,
      b: params[`${prefix}B`] ?? fallback.b,
    };
  }
  return fallback;
}
